import React from 'react';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { connect } from 'react-redux';
import Avatar from 'material-ui/Avatar';

import noCrashPin from 'Content/Assets/images/maps/black_48.png';
import heavyPin from 'Content/Assets/images/maps/heavy_48.png';
import lightPin from 'Content/Assets/images/maps/light_48.png';
import veryHeavyPin from 'Content/Assets/images/maps/veryHeavy_48.png';
import veryLightPin from 'Content/Assets/images/maps/veryLight_48.png';
import moderatePin from 'Content/Assets/images/maps/moderate_48.png';
import styles from './styles/severityPinLegendStyles';

import {BottomNavigation, BottomNavigationItem} from 'material-ui/BottomNavigation';
import Paper from 'material-ui/Paper';
import $ from 'jquery';

class SeverityPinLegend extends React.Component {
    constructor(props){
        super(props);
        this.calculateSeverity = this.calculateSeverity.bind(this);
    }

    calculateSeverity(list){
        var summarize = {nonCrash: 0, light: 0, veryLight: 0, moderate: 0, heavy: 0, veryHeavy:0 };

        if(!list) return summarize;

        $.each(list, function (index, item){
            var icn = item.icn;
            if(icn.severityCode === "NonCrash")
            {
                summarize.nonCrash += 1;
            }
            if(icn.severityCode === "VeryLight")
            {
                summarize.veryLight += 1;
            }
            else if(icn.severityCode === "VeryHeavy")
            {
                summarize.veryHeavy += 1;
            }
            else if(icn.severityCode === "Light")
            {
                summarize.light += 1;
            }
            else if(icn.severityCode === "Moderate")
            {
                summarize.moderate += 1;
            }
            else if(icn.severityCode === "Heavy")
            {
                summarize.heavy += 1;
            }
        });

        return summarize;
    }

    render() {
        const {mapList} = this.props;

        var summarize = this.calculateSeverity(mapList);

        return (
            <Paper zDepth={1}>
                <BottomNavigation >
                    <BottomNavigationItem
                        label={"Non crash: " + summarize.nonCrash}
                        icon={
                            <Avatar
                                src={noCrashPin}
                                size={25}
                                style={styles.iconStyle}
                            />
                        }
                    />

                    <BottomNavigationItem
                        label={"Very light: " + summarize.veryLight}
                        icon={
                            <Avatar
                                src={veryLightPin}
                                size={25}
                                style={styles.iconStyle}
                            />
                        }
                    />
                    <BottomNavigationItem
                        label={"Light: " + summarize.light}
                        icon={
                            <Avatar
                                src={lightPin}
                                size={25}
                                style={styles.iconStyle}
                            />
                        }
                    />
                    <BottomNavigationItem
                        label={"Moderate: " + summarize.moderate}
                        icon={
                            <Avatar
                                src={moderatePin}
                                size={25}
                                style={styles.iconStyle}
                            />
                        }
                    />
                    <BottomNavigationItem
                        label={"Heavy: " + summarize.heavy}
                        icon={
                            <Avatar
                                src={heavyPin}
                                size={25}
                                style={styles.iconStyle}
                            />
                        }
                    />
                    <BottomNavigationItem
                        label={"Very heavy: " + summarize.veryHeavy}
                        icon={
                            <Avatar
                                src={veryHeavyPin}
                                size={25}
                                style={styles.iconStyle}
                            />
                        }
                    />
                </BottomNavigation>
            </Paper>
        );
    }
}

SeverityPinLegend.propTypes = {
    //x: PropTypes.object,
    //x: PropTypes.func,
    //x: PropTypes.bool,
    //x: PropTypes.array.isRequired,
    //x: PropTypes.object.isRequired
}

function mapStateToProps(state, ownProps){
    console.info(state);
    return {
        translate: getTranslate(state.locale),
        currentLanguage: getActiveLanguage(state.locale).code,
        mapList: state.icnSearch.mapList,
        mapTotalCount: state.icnSearch.mapTotalCount,
        isIcnLoading: state.icnSearch.isSearching
    }
}
export default connect(mapStateToProps, null)(SeverityPinLegend);


// WEBPACK FOOTER //
// ./src/components/crashDashboard/severityPinLegend.js